/* Penoblo Kategorien-Finder: Tab-Wechsel (Kategorien/Marken) + "Mehr anzeigen". */
class PnbFinder extends HTMLElement {
  connectedCallback() {
    this.tabs = [...this.querySelectorAll('.fd-tab')];
    this.panels = {
      cat: this.querySelector('[data-panel="cat"]'),
      brand: this.querySelector('[data-panel="brand"]'),
    };
    this.moreWrap = this.querySelector('[data-more]');
    this.moreBtn = this.querySelector('[data-more-btn]');
    this.moreLabel = this.querySelector('[data-more-label]');
    this.limits = { cat: parseInt(this.dataset.visibleCat || '6', 10), brand: parseInt(this.dataset.visibleBrand || '10', 10) };
    this.tab = 'cat';
    this.open = false;

    // Listener an ein AbortController-Signal binden -> disconnectedCallback raeumt
    // sie (inkl. window-resize) bei Section-Unload ab.
    const signal = (this._ac = new AbortController()).signal;

    this.tabs.forEach((t) => t.addEventListener('click', () => this.switch(t.dataset.tab), { signal }));
    const fdTablist = this.querySelector('.fd-tabs');
    if (fdTablist) fdTablist.addEventListener('keydown', (e) => {
      const i = this.tabs.indexOf(document.activeElement);
      if (i < 0) return;
      const n = e.key === 'ArrowRight' ? (i + 1) % this.tabs.length
        : e.key === 'ArrowLeft' ? (i - 1 + this.tabs.length) % this.tabs.length
        : e.key === 'Home' ? 0 : e.key === 'End' ? this.tabs.length - 1 : -1;
      if (n < 0) return;
      e.preventDefault(); this.switch(this.tabs[n].dataset.tab); this.tabs[n].focus();
    }, { signal });
    if (this.moreBtn) this.moreBtn.addEventListener('click', () => { this.open = !this.open; this.apply(); }, { signal });
    let mob = this.isMobile();
    window.addEventListener('resize', () => { const m = this.isMobile(); if (m !== mob) { mob = m; this.apply(); } }, { signal });
    this.apply();
  }

  disconnectedCallback() {
    if (this._ac) this._ac.abort();
  }

  isMobile() { return window.matchMedia('(max-width: 749px)').matches; }

  // Auf Mobil weniger Kacheln initial zeigen -> "Mehr anzeigen" greift frueher
  limitFor(tab) {
    if (this.isMobile()) return Math.min(this.limits[tab], tab === 'cat' ? 4 : 6);
    return this.limits[tab];
  }

  switch(tab) {
    if (!this.panels[tab]) return;
    this.tab = tab;
    this.open = false;
    this.tabs.forEach((t) => {
      const on = t.dataset.tab === tab;
      t.classList.toggle('on', on);
      t.setAttribute('aria-selected', on);
      t.tabIndex = on ? 0 : -1;
    });
    Object.keys(this.panels).forEach((k) => { if (this.panels[k]) this.panels[k].hidden = k !== tab; });
    this.apply();
  }

  apply() {
    const panel = this.panels[this.tab];
    if (!panel) return;
    const cells = [...panel.querySelectorAll('.fd-cell')];
    const limit = this.limitFor(this.tab);
    cells.forEach((c, i) => c.classList.toggle('fd-hidden', !this.open && i >= limit));
    if (!this.moreWrap) return; // ohne "Mehr"-UI nichts weiter zu tun
    const hidden = cells.length - Math.min(cells.length, this.open ? cells.length : limit);
    if (cells.length > limit) {
      this.moreWrap.hidden = false;
      if (this.moreBtn) this.moreBtn.classList.toggle('open', this.open);
      if (this.moreLabel) this.moreLabel.textContent = this.open
        ? (this.dataset.lessLabel || 'Weniger anzeigen')
        : (this.dataset.moreLabel || 'Mehr anzeigen') + ' (' + hidden + ')';
    } else {
      this.moreWrap.hidden = true;
    }
  }
}
if (!customElements.get('pnb-finder')) customElements.define('pnb-finder', PnbFinder);
